module.exports = __webpack_public_path__ + "static/fonts/Outage.f7fcded.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Outage.ttf
// module id = 7Y1O
// module chunks = 1